<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Request for New User Account
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-card>
      <b-alert
        variant="warning"
        show
      >
        <div class="alert-body d-flex">
          <feather-icon
            icon="AlertTriangleIcon"
            size="18"
            class="my-auto mr-1"
          />
          <span><strong>You can request for a new user to be added to your department(s), within selected roles.</strong> Your request will be reviewed and both you and the new user will receive an email if the request is approved.</span>
        </div>
      </b-alert>
      <validation-observer
        ref="userCreateForm"
        #default="{invalid}"
      >
        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col cols="md-6">
              <b-form-group
                label="Name*"
                label-for="h-user-name"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="h-user-name"
                    v-model="name"
                    placeholder="Name"
                    :state="(errors.length > 0 || nameValidation) ? false : null"
                    name="name"
                    @input="nameValidation == true ? nameValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="nameValidation"
                    class="text-danger"
                  >
                    {{ nameError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-6" />

            <b-col cols="md-6">
              <b-form-group
                label="Position*"
                label-for="h-user-position"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Position"
                  vid="position"
                  rules="required"
                >
                  <b-form-input
                    id="h-user-position"
                    v-model="position"
                    placeholder="Manager"
                    :state="(errors.length > 0 || positionValidation) ? false : null"
                    name="position"
                    @input="positionValidation == true ? positionValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="positionValidation"
                    class="text-danger"
                  >
                    {{ positionError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-6" />

            <b-col cols="md-6">
              <validation-provider
                #default="{ errors }"
                name="Department"
                vid="department"
                rules="required"
              >
                <b-form-group
                  label="Department*"
                  label-for="h-user-department"
                  label-cols-md="4"
                  :state="(errors.length > 0 || departmentValidation) ? false : null"
                >
                  <v-select
                    id="h-user-department"
                    v-model="department"
                    label="name"
                    placeholder="Choose a Department"
                    multiple
                    :options="departments"
                    :reduce="name => name._id"
                    :clearable="false"
                    @input="departmentValidation == true ? departmentValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="departmentValidation"
                    class="text-danger"
                  >
                    {{ departmentError }}
                  </small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="md-6" />

            <b-col cols="md-6">
              <b-form-group
                label="Email*"
                label-for="h-user-email"
                label-cols-md="4"
                description="Only email addresses on official Nirvana domain names are accepted."
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="h-user-email"
                    v-model="email"
                    v-b-tooltip.hover.top="'Allowed domains: @nirvana.com.sg, @nvasia.com.sg, @nvasia.com.my, @linsan.sg'"
                    placeholder="Email"
                    :state="(errors.length > 0 || emailValidation) ? false : null"
                    name="email"
                    @input="emailValidation == true ? emailValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="emailValidation"
                    class="text-danger"
                  >
                    {{ emailError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-6" />

            <b-col cols="md-12">
              <validation-provider
                #default="{ errors }"
                name="Roles"
                vid="roles"
                rules="required"
              >
                <b-form-group
                  label="Roles*"
                  label-for="h-user-role"
                  label-cols-md="2"
                  :state="(errors.length > 0 || roleValidation) ? false : null"
                >
                  <v-select
                    id="h-user-role"
                    v-model="roles"
                    label="role"
                    placeholder="Choose role(s)"
                    multiple
                    :options="compRoleOptions"
                    :reduce="name => name._id"
                    :clearable="false"
                    @input="roleValidation == true ? roleValidation = false : null"
                  >
                    <template #option="{ _id, role, description }">
                      <span :class="{ 'text-primary': !roles.includes(_id) }">{{ role }}</span>
                      <br>
                      <span class="fs-12">{{ description }}</span>
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="roleValidation"
                    class="text-danger"
                  >
                    {{ roleError }}
                  </small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="md-12">
              <b-form-group
                label="Remarks*"
                label-for="h-user-remarks"
                label-cols-md="2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="remarks"
                  vid="remarks"
                  rules="required"
                >
                  <b-form-textarea
                    id="h-user-remarks"
                    v-model="remarks"
                    placeholder="Please share any additional requests, background information or information on why this user requires certain user roles."
                    :state="(errors.length > 0 || remarksValidation) ? false : null"
                    name="remarks"
                    @input="remarksValidation == true ? remarksValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="remarksValidation"
                    class="text-danger"
                  >
                    {{ remarksError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-nav class="wrap-border save-nav">
            <li
              class="nav-item ml-auto"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="button"
                variant="flat-primary"
                :to="{ name: 'directory-users-requests-index' }"
              >
                Cancel
              </b-button>
            </li>
            <li
              class="nav-item mr-1"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="success"
                :disabled="invalid"
              >
                <feather-icon
                  icon="SendIcon"
                  class="mr-50"
                />
                <span class="align-middle">Submit Account Request</span>
              </b-button>
            </li>
          </b-nav>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BNav, BFormTextarea, BAlert, VBTooltip,
} from 'bootstrap-vue'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { required, min } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BNav,
    BAlert,
    BFormTextarea,

    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      user: store.state.auth.userData,
      name: '',
      position: '',
      department: [],
      email: '',
      remarks: '',
      roles: [],
      nameError: 'Valid name is required',
      nameValidation: false,
      positionError: 'Valid position is required',
      positionValidation: false,
      departmentError: 'Valid department is required',
      departmentValidation: false,
      emailError: 'Valid email is required',
      emailValidation: false,
      remarksError: 'Valid remarks is required',
      remarksValidation: false,
      roleError: 'Valid role is required',
      roleValidation: false,
      option: [{ title: 'Active', code: 'active' }, { title: 'Inactive', code: 'inactive' }],
      roleOptions: [],
      departments: [],
      allRoleOptions: [],

      // validation rules
      required,
      min,
    }
  },
  computed: {
    compRoleOptions() {
      if (!this.department.length) return []
      return this.allRoleOptions.filter(role => this.department.some(dep => role.departments.includes(dep)))
    },
  },
  beforeMount() {
    this.$http.get('directory/users/respond-with/extra-options')
      .then(response => {
        this.allRoleOptions = response.data.roleOptions ?? []
        this.departments = response.data.departments
        // this.departments = this.user.department
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    resolveRoleName(role) {
      const type = this.roleOptions.find(o => o._id === role)
      if (type) {
        return type.role
      }
      return ''
    },
    submitForm() {
      this.$refs.userCreateForm.validate().then(success => {
        if (success) {
          const formData = new FormData()

          formData.append('name', this.name)
          formData.append('url', window.location.origin)
          formData.append('position', this.position)
          // formData.append('department', this.department)
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.department.length; i++) {
            formData.append('department[]', this.department[i])
          }
          formData.append('email', this.email)
          formData.append('remarks', this.remarks)
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.roles.length; i++) {
            formData.append('roles[]', this.roles[i])
          }
          this.$http.post('directory/users/requests/store', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(() => {
              this.$swal({
                title: 'User Request Submitted',
                html: '<br>Your request to create a new user has been<br>successfully submitted. Our team will<br>review and process the request shortly.<br>You’ll be notified once it’s approved or if any<br>further action is required.',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/success.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Ok, got it',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
                width: 408,
              })
                .then(result => {
                  if (result.value) {
                    this.$router.push({ name: 'directory-users-requests-index' })
                  }
                })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'name') {
                    this.nameError = validationError.msg
                    this.nameValidation = true
                  } else if (validationError.param === 'position') {
                    this.positionError = validationError.msg
                    this.positionValidation = true
                  } else if (validationError.param === 'department') {
                    this.departmentError = validationError.msg
                    this.departmentValidation = true
                  } else if (validationError.param === 'email') {
                    this.emailError = validationError.msg
                    this.emailValidation = true
                  } else if (validationError.param === 'roles') {
                    this.roleError = validationError.msg
                    this.roleValidation = true
                  }
                })

                const items = document.getElementsByClassName('text-danger')
                window.scrollTo({
                  top: items[0].offsetTop,
                  behavior: 'smooth',
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>
